import React from 'react';
import { Helmet } from 'react-helmet-async';
import type { SEOMeta } from '../types/seo.types';

interface Props {
    seo: SEOMeta;
}

export const SEOHead: React.FC<Props> = ({ seo }) => (
    <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        {seo.keywords && <meta name="keywords" content={seo.keywords} />}
        <link rel="canonical" href={seo.canonical} />
        <meta name="robots" content={seo.noIndex ? 'noindex,nofollow' : 'index,follow'} />

        <meta property="og:title" content={seo.ogTitle ?? seo.title} />
        <meta property="og:description" content={seo.ogDescription ?? seo.description} />
        <meta property="og:url" content={seo.canonical} />
        <meta property="og:type" content={seo.ogType ?? 'website'} />
        {seo.ogImage && <meta property="og:image" content={seo.ogImage} />}

        <meta name="twitter:card" content={seo.twitterCard ?? 'summary_large_image'} />
        <meta name="twitter:title" content={seo.ogTitle ?? seo.title} />
        <meta name="twitter:description" content={seo.description} />
        {seo.ogImage && <meta name="twitter:image" content={seo.ogImage} />}
    </Helmet>
);
